import objUtil from './ObjUtil.js';
const arrayUtil = {
  /**
   * 将传进来的list:[{id:'',name:''},{id:'',name:''},{id:'',name:''},]转换为{id1:name1,id2:name2,id3:name3}对象形式
   * 可以指定要转换的两个字段
   * 要保证id不能重复
   * @param list   数组
   * @param attr1  key
   * @param attr2  value
   * @returns {{}}
   */
  transferList2Obj(list, attr1 = 'id', attr2 = 'name') {
    const result = {};
    if (list && list.length) {
      list.forEach((v) => {
        if (attr1 in v && attr2 in v) {
          result[v[attr1]] = v[attr2]
        }
      })
    }
    return result
  },
  
    /**
     *
     * @param list
     * @param attr1
     * @param attr2 数组类型
     */
    transferList2Obj1(list, attr1 = 'id', attr2 = 'name') {
        const result = {};
        if (list && list.length) {
            list.forEach((v) => {
                if (attr1 in v && attr2 in v) {
                    result[v[attr1]] = v[attr2].slice(0)
                }
            })
        }
        return result
    },

  /**
   * 带有函数参数的翻译方法
   * @param list
   * @param attr1
   * @param attr2
   * @param fuc
   */
  transferList2ObjWithFuc(list, attr1 = 'id', attr2 = 'name', fuc) {
    const result = {};
    if (list && list.length) {
      list.forEach((v) => {
        if (fuc(v) && attr1 in v && attr2 in v) {
          result[v[attr1]] = v[attr2]
        }
      })
    }
    return result
  },
  transferList2SpecialObj(list, attr1 = 'id') {
    const result = {};
    if (list && list.length) {
      list.forEach((v) => {
        result[v[attr1]] = v
      })
    }
    return result
  },
  transBoolToNum(list, attr) {
    const arr = [];
    if (list && list.length) {
      for (let item of list) {
        if ({}.hasOwnProperty.call(item, attr)) {
          const obj = Object.assign({}, item);
          obj[attr] = obj[attr] ? 1 : 0;
          arr.push(obj)
        }
      }
    }
    return arr.length ? arr : list
  },
  cloneArr(arr){
    let resultArr = [];
    for(var item of arr){
        resultArr.push(objUtil.clone(item));
    }
    return resultArr;
  },
  /**
   * 将数据里指定字段转换成id和name
   * @param arr 数组，比如[{gameId: 1, game: { name: '游戏一', type: 1 }}, {gameId: 2, game: { name: '游戏二', type: 2 }}]
   * @param attr1 将要被转换成id的属性，比如gameId
   * @param attr2 将要被转换成name的属性，比如game.name
   * @returns {Array} [{ id: 1, name: '游戏一' }, { id: 2, name: '游戏二' }]
   */
  gamesHandler(arr, attr1, attr2) {
    const allGames =[];
    if (arr === null) return allGames;
    if (attr1 === undefined || attr2 === undefined) return allGames;
    const nameArr = attr2.split('.');
    arr.forEach((i) => {
      if ({}.hasOwnProperty.call(i, attr1) && i[attr1] !== null) {
        let obj = i;
        nameArr.forEach((j) => {
          obj = obj[j]
        });
        const item = {};
        item.id = i[attr1];
        item.name = obj;
        allGames.push(item)
      }
    } );
    return allGames
  },
  /**
   * 获取穿梭框里选中的值
   * @param arr 数组
   */
  getSelectedValue(arr) {
    const selectedValue = [];
    arr.forEach((item) => {
      if ({}.hasOwnProperty.call(item, 'select')) {
        if (item.select) {
          selectedValue.push(item.key)
        }
      }
    });
    return selectedValue
  },
  /**
   * 获取穿梭框里选中的值
   * @param arr 数组
   */
  getSelectedFields(arr, field = 'key') {
    const selectedValue = [];
    arr.forEach((item) => {
      if ({}.hasOwnProperty.call(item, field)) {
          selectedValue.push(item[field])
      }
    });
    return selectedValue
  },
  isEmpty(arr){
      if(arr==null || arr == undefined || arr.length==0){
          return true;
      }
      return false;
  },
  iosRewardTranslate(arr){
    const value = [];
      if (arr && arr.length) {
        arr.forEach((item)=>{
          value.push(item.goods.name +" * " +item.number)
        })
      }
   return value.join(" , ");
  }
};
export default arrayUtil
